import { compose, lifecycle, withStateHandlers } from 'recompose';
import { hot } from 'react-hot-loader';

import { defaultAppData } from '../Shared/constants';
import { log } from '../Shared/UIEventLogger/UIEventLogger';
import api from '../Shared/Services/api';
import Root from './Root';

const enhance = compose(
  withStateHandlers(
    {
      isAppDataLoaded: window.App ? true : process.env.NODE_ENV === 'production', // always assume the data is loaded in prod
    },
    {
      setAppDataLoaded: ({ isAppDataLoaded }) => loaded => ({
        isAppDataLoaded: loaded,
      }),
    }
  ),
  lifecycle({
    componentDidMount() {
      const { isAppDataLoaded, setAppDataLoaded } = this.props;
      if (!isAppDataLoaded) {
        log(
          'App Data not loaded (front end running in node). Attempting to populate window.App via the API...'
        );
        api
          .getJson('/localization' + window.location.search) // pass along any query params (mainly for culture/ui-culture)
          .then(locInfo => {
            window.App = defaultAppData;
            window.App.localizationInfo = locInfo;
            if (Boolean(window.sessionStorage) && sessionStorage.getItem('developmentUserData')) {
              window.App.user = JSON.parse(sessionStorage.getItem('developmentUserData'));
            }
            log('App Data successfully loaded.');
            setAppDataLoaded(true);
          })
          .catch(error => {
            // ignore errors; the api may not be running on the dev server
            log(
              'App Data could not be loaded. Is the API running? You will not see localized translations. ',
              error
            );
          });
      }
    },
  })
);

export default hot(module)(enhance(Root));



// WEBPACK FOOTER //
// ./src/Root/RootContainer.js